<template>
  <div class="row">
    <div class="col-12">
      <div class="form-group row mb-3">
        <label class="col-md-3 col-form-label" for="title">
          {{ $t("malware.risk-score") }}</label
        >
        <div class="col-md-9">
          <vue-slide-bar
            ref="riskscore"
            v-model="form.riskscore"
            :min="0"
            :max="100"
          />
          <b-button-group class="mt-1 btn-group-sm">
            <b-button variant="secondary" @click="form.riskscore -= 1">
              <i class="fas fa-minus"></i>
            </b-button>
            <b-form-input
              ref="input-size"
              size="sm"
              for="text"
              :value="form.riskscore"
              maxlength="4"
              v-model="form.riskscore"
              style="width: 35px"
            ></b-form-input>
            <b-button variant="secondary" @click="form.riskscore += 1">
              <i class="fas fa-plus"></i>
            </b-button>
          </b-button-group>
        </div>
      </div>
      <div class="form-group row mb-3">
        <label class="col-md-3 col-form-label" for="title">Tags</label>
        <div class="col-md-9">
          <b-form-tags
            input-id="tags-separators"
            v-model="form.tags"
            placeholder="Separated word with enter"
            remove-on-delete
          />
        </div>
      </div>

      <div class="form-group row mb-3">
        <label class="col-md-3 col-form-label" for="desc">
          {{ $t("malware.note") }}</label
        >
        <div class="col-md-9">
          <textarea
            name="description"
            id="desc"
            class="form-control"
            cols="30"
            rows="10"
            v-model="form.note"
          ></textarea>
        </div>
      </div>
    </div>
    <!-- end col -->
  </div>
</template>

<script>
// import { required } from "vuelidate/lib/validators";
import VueSlideBar from "vue-slide-bar";
import ReportService from "@/helpers/report.service";
import { userService } from "@/helpers/authservice/user.service";
import moment from "moment";

/**
 * Projects-grid component
 */
export default {
  components: { VueSlideBar },
  props: {
    validations: Boolean,
    refreshSlider: Boolean,
    idReport: { type: String, default: "" },
  },
  data() {
    return {
      submitted: false,
      form: {
        riskscore: 0,
        tags: [],
        note: "",
      },
      theme: localStorage.getItem("theme") ?? "light",
      tags: [],
      riskscore: 20,
    };
  },
  // validations: {
  //   form: {
  //     riskscore: { required },
  //   },
  // },
  watch: {
    validations: {
      immediate: true,
      handler(n) {
        if (n) {
          this.finishReport();
        }
      },
    },
    refreshSlider: {
      immediate: true,
      handler(n) {
        if (n) {
          this.refresh();
        }
      },
    },
  },
  methods: {
    finishReport() {
      let ferr = 0;
      const dataReport = {
        risk_score: this.form.riskscore,
        tags: this.form.tags,
        note: this.form.note,
      };
      ReportService.finish(this.idReport, dataReport)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.updateReport();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.$emit("complete");
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.finishReport();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading = false;
            }
            this.$emit("validation-failed");
            this.submitted = false;
            setTimeout(() => {
              this.submitted = true;
              this.isValid = false;
            }, 200);
          }
        });
    },

    detailReport() {
      let ferr = 0;
      if (this.idReport) {
        ReportService.detail(this.idReport)
          .then((res) => {
            if (res.status == 201) {
              let new_token = res.data.refresh_access_token;
              userService.splitToken(new_token);
              this.detailReport();
              ferr = 1;
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              // console.log("ters ", res.data.data);
              ferr = 2;
              this.form = {
                riskscore: res.data.data.risk_score,
                tags: JSON.parse(res.data.data.tags),
                note: res.data.data.note,
              };
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.detailReport();
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log("err ->> ", err);
              }
            }
          });
      }
    },

    refresh() {
      this.$refs.riskscore.refresh();
    },
  },
  mounted() {
    this.detailReport();
  },
};
</script>